export default {
    clearKeyedMessage(state, payload) { 
        // delete state.sharedmessages[payload];
        state.sharedmessages[payload] = [];
        state.sharedmessagestatus = 'complete';
    },
    addKeyedMessage(state, payload) { 
        state.sharedmessages[payload.key] = payload.messages;
        state.sharedmessagestatus = 'complete';
    },
    resetStatus(state) {
        state.sharedmessagestatus = 'pending';
    }
}